import { makeStyles } from '@mui/styles'

const styles = makeStyles(() => ({
  container: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '0.25rem',
    padding: '1rem',
    '& > span': {
      width: '100%',
    },
    '& > p': {
      fontSize: 12,
    },
  },
}))

export default styles
